// import React, { useEffect, useState } from "react";
// import {
//   format,
//   startOfMonth,
//   endOfMonth,
//   eachDayOfInterval,
//   isToday,
//   parseISO,
// } from "date-fns";
// import {
//   Users,
//   Calendar,
//   FileText,
//   Plus,
//   Trash2,
//   Edit2,
//   Check,
//   X,
//   ChevronLeft,
//   ChevronRight,
//   Clock,
//   Wallet,
//   Eye,
// } from "lucide-react";
// import { Api } from "../Api/Api";

// /* ---------------- HELPERS ---------------- */
// const cn = (...c) => c.filter(Boolean).join(" ");
// const daysInMonth = (y, m) => new Date(y, m + 1, 0).getDate();
// const apiGet = async (url) => (await fetch(Api + url)).json();
// const apiPost = async (url, body) =>
//   (
//     await fetch(Api + url, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(body),
//     })
//   ).json();

// export default function AttendanceDashboard() {
//   const [tab, setTab] = useState("staff");
//   const [staff, setStaff] = useState([]);
//   const [attendance, setAttendance] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [month, setMonth] = useState(startOfMonth(new Date()));
//   const [reportMonth, setReportMonth] = useState(format(new Date(), "yyyy-MM"));
//   const [viewDetailId, setViewDetailId] = useState(null);

//   const [inputs, setInputs] = useState({});
//   const [editingId, setEditingId] = useState(null);
//   const [newStaff, setNewStaff] = useState({
//     name: "",
//     mobileNumber: "",
//     designation: "",
//     monthlySalary: "",
//   });
//   const [editStaff, setEditStaff] = useState({});

//   /* ---------------- LOAD ---------------- */
//   const loadStaff = async () => setStaff(await apiGet("staff/list.php"));

//   const loadAttendance = async () => {
//     if (tab === "reports") {
//       setAttendance(await apiGet(`attendance/list.php?month=${reportMonth}`));
//     } else {
//       setAttendance(
//         await apiGet(
//           `attendance/list.php?date=${format(selectedDate, "yyyy-MM-dd")}`,
//         ),
//       );
//     }
//   };

//   useEffect(() => {
//     loadStaff();
//   }, []);
//   useEffect(() => {
//     loadAttendance();
//   }, [selectedDate, reportMonth, tab]);

//   /* ---------------- STAFF ACTIONS ---------------- */
//   const addStaff = async () => {
//     if (!newStaff.name || !newStaff.monthlySalary)
//       return alert("Name & salary required");
//     await apiPost("staff/create.php", newStaff);
//     setNewStaff({
//       name: "",
//       mobileNumber: "",
//       designation: "",
//       monthlySalary: "",
//     });
//     loadStaff();
//   };

//   const deleteStaff = async (id) => {
//     if (!window.confirm("Delete staff?")) return;
//     await apiGet(`staff/delete.php?id=${id}`);
//     loadStaff();
//   };

//   const updateStaff = async () => {
//     await apiPost("staff/update.php", editStaff);
//     setEditingId(null);
//     loadStaff();
//   };

//   /* ---------------- ATTENDANCE ACTIONS ---------------- */

//   // Mark In-Time Only
//   const markInTime = async (s) => {
//     const date = format(selectedDate, "yyyy-MM-dd");
//     const inp = inputs[s.id] || {};

//     if (!inp.inTime) return alert("Please select in-time first");

//     await apiPost("attendance/mark-time.php", {
//       id: `${s.id}-${date}`,
//       staffId: s.id,
//       date,
//       inTime: inp.inTime,
//       timeType: "in",
//     });
//     loadAttendance();
//     setInputs({ ...inputs, [s.id]: {} });
//   };

//   // Mark Out-Time Only
//   const markOutTime = async (s) => {
//     const date = format(selectedDate, "yyyy-MM-dd");
//     const inp = inputs[s.id] || {};

//     if (!inp.outTime) return alert("Please select out-time first");

//     const rec = attendance.find((a) => a.staff_id === s.id && a.date === date);
//     if (!rec) return alert("Please mark in-time first");

//     const [y, m] = date.split("-").map(Number);
//     const daily = s.monthly_salary / daysInMonth(y, m - 1);
//     const pay =
//       rec.status === "present"
//         ? daily
//         : rec.status === "half-day"
//           ? daily / 2
//           : rec.status === "absent"
//             ? 0
//             : daily;

//     await apiPost("attendance/mark-time.php", {
//       id: `${s.id}-${date}`,
//       staffId: s.id,
//       date,
//       outTime: inp.outTime,
//       timeType: "out",
//       dailySalary: pay,
//     });
//     loadAttendance();
//     setInputs({ ...inputs, [s.id]: {} });
//   };

//   // Mark Attendance Status (P/H/A)
//   const markAttendance = async (s, status) => {
//     const date = format(selectedDate, "yyyy-MM-dd");
//     const rec = attendance.find((a) => a.staff_id === s.id && a.date === date);

//     if (!rec) return alert("Please mark in-time first");

//     const [y, m] = date.split("-").map(Number);
//     const daily = s.monthly_salary / daysInMonth(y, m - 1);
//     const pay =
//       status === "present" ? daily : status === "half-day" ? daily / 2 : 0;

//     await apiPost("attendance/update-status.php", {
//       id: `${s.id}-${date}`,
//       status,
//       dailySalary: pay,
//     });
//     loadAttendance();
//   };

//   /* ---------------- UI COMPONENTS ---------------- */
//   const StatusBadge = ({ status }) => {
//     const colors = {
//       present: "bg-green-100 text-green-700",
//       "half-day": "bg-yellow-100 text-yellow-700",
//       absent: "bg-red-100 text-red-700",
//       pending: "bg-gray-100 text-gray-600",
//     };
//     return (
//       <span
//         className={cn(
//           "px-2 py-1 rounded-md text-[10px] font-bold uppercase",
//           colors[status],
//         )}
//       >
//         {status}
//       </span>
//     );
//   };

//   const formatIndianTime = (time) => {
//   if (!time) return "--:--";
//   const [h, m] = time.split(":");
//   const date = new Date();
//   date.setHours(h, m);
//   return date.toLocaleTimeString("en-IN", {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });
// };


//                   const grandTotalSalary = staff.reduce((sum, s) => {
//   const recs = attendance.filter(
//     (a) => a.staff_id === s.id && a.date.startsWith(reportMonth)
//   );
//   const total = recs.reduce(
//     (t, r) => t + Number(r.daily_salary || 0),
//     0
//   );
//   return sum + total;
// }, 0);


//   return (
//     <div className="min-h-screen bg-slate-50 pb-20">
//       {/* STICKY HEADER */}
//       <div className="sticky top-0 z-10 bg-white border-b px-4 py-3 mb-6">
//         <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
//           <h1 className="text-xl font-bold text-slate-800">Staff ERP</h1>
 

//           <div className="flex bg-slate-100 p-1 rounded-xl w-full md:w-auto overflow-x-auto no-scrollbar">
//   {[
//     { id: "staff", label: "Staff", icon: Users },
//     { id: "attendance", label: "Attendance", icon: Calendar },
//     { id: "reports", label: "Payroll", icon: FileText },
//   ].map((t) => (
//     <button
//       key={t.id}
//       onClick={() => setTab(t.id)}
//       className={cn(
//         // flex-1: grow on mobile | md:flex-none: fixed width on desktop
//         // px-2: small padding on mobile | md:px-4: larger on desktop
//         "flex-1 md:flex-none px-2 md:px-4 py-2 flex items-center justify-center gap-2 rounded-lg transition-all whitespace-nowrap",
//         tab === t.id
//           ? "bg-white shadow-sm text-indigo-600"
//           : "text-slate-500 hover:text-slate-700"
//       )}
//     >
//       <t.icon size={18} className="shrink-0" />
//       {/* Hide text on very small screens, show on mobile-medium (sm) and up */}
//       <span className="hidden sm:inline text-sm font-medium">
//         {t.label}
//       </span>
//     </button>
//   ))}
// </div>
//         </div>
//       </div>

//       <main className="max-w-7xl mx-auto px-4">
//         {/* ================= STAFF TAB ================= */}
//         {tab === "staff" && (
//           <div className="space-y-6">
//             <div className="bg-white p-6 rounded-2xl border shadow-sm">
//               <h3 className="font-bold mb-4 flex items-center gap-2 text-slate-700">
//                 <Plus size={20} /> Add New Staff
//               </h3>
//               <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
//                 <input
//                   placeholder="Full Name"
//                   className="border p-2.5 rounded-lg focus:ring-2 ring-indigo-100 outline-none"
//                   value={newStaff.name}
//                   onChange={(e) =>
//                     setNewStaff({ ...newStaff, name: e.target.value })
//                   }
//                 />
//                 <input
//                   placeholder="Designation"
//                   className="border p-2.5 rounded-lg focus:ring-2 ring-indigo-100 outline-none"
//                   value={newStaff.designation}
//                   onChange={(e) =>
//                     setNewStaff({ ...newStaff, designation: e.target.value })
//                   }
//                 />
//                 <input
//                   placeholder="Mobile Number"
//                   className="border p-2.5 rounded-lg focus:ring-2 ring-indigo-100 outline-none"
//                   value={newStaff.mobileNumber}
//                   onChange={(e) =>
//                     setNewStaff({ ...newStaff, mobileNumber: e.target.value })
//                   }
//                 />
//                 <input
//                   placeholder="Monthly Salary"
//                   type="number"
//                   className="border p-2.5 rounded-lg focus:ring-2 ring-indigo-100 outline-none"
//                   value={newStaff.monthlySalary}
//                   onChange={(e) =>
//                     setNewStaff({ ...newStaff, monthlySalary: e.target.value })
//                   }
//                 />
//                 <button
//                   onClick={addStaff}
//                   className="md:col-span-4 bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 rounded-lg transition-colors"
//                 >
//                   SAVE STAFF MEMBER
//                 </button>
//               </div>
//             </div>

//             <div className="bg-white rounded-2xl border shadow-sm overflow-hidden">
//               <div className="overflow-x-auto">
//                 <table className="w-full text-left border-collapse">
//                  <thead>
//   <tr className="bg-slate-50 text-slate-500 text-sm uppercase">
//     <th className="p-4 font-semibold w-12">#</th>
//     <th className="p-4 font-semibold">Staff Details</th>
//     <th className="p-4 font-semibold">Designation</th>
//     <th className="p-4 font-semibold">Salary</th>
//     <th className="p-4 font-semibold text-right">Actions</th>
//   </tr>
// </thead>

//                   <tbody className="divide-y">
//                     {/* {staff.map((s) => ( */}
//                     {staff.map((s, index) => (

//                       <tr
//                         key={s.id}
//                         className="hover:bg-slate-50 transition-colors"
//                       >
//                         <td className="p-4 font-bold text-slate-600">
//   {index + 1}
// </td>

//                         {editingId === s.id ? (
//                           <>
//                             <td className="p-4">
//                               <input
//                                 className="border p-2 rounded w-full"
//                                 value={editStaff.name}
//                                 onChange={(e) =>
//                                   setEditStaff({
//                                     ...editStaff,
//                                     name: e.target.value,
//                                   })
//                                 }
//                               />
//                               <input
//                                 className="border p-2 rounded w-full mt-1"
//                                 value={editStaff.mobile_number}
//                                 onChange={(e) =>
//                                   setEditStaff({
//                                     ...editStaff,
//                                     mobile_number: e.target.value,
//                                   })
//                                 }
//                               />
//                             </td>

//                             <td className="p-4">
//                               <input
//                                 className="border p-2 rounded w-full"
//                                 value={editStaff.designation}
//                                 onChange={(e) =>
//                                   setEditStaff({
//                                     ...editStaff,
//                                     designation: e.target.value,
//                                   })
//                                 }
//                               />
//                             </td>

//                             <td className="p-4">
//                               <input
//                                 type="number"
//                                 className="border p-2 rounded w-full"
//                                 value={editStaff.monthly_salary}
//                                 onChange={(e) =>
//                                   setEditStaff({
//                                     ...editStaff,
//                                     monthly_salary: e.target.value,
//                                   })
//                                 }
//                               />
//                             </td>

//                             <td className="p-4 text-right space-x-2">
//                               <button
//                                 onClick={updateStaff}
//                                 className="p-2 text-green-600 hover:bg-green-50 rounded-full"
//                               >
//                                 <Check size={18} />
//                               </button>

//                               <button
//                                 onClick={() => setEditingId(null)}
//                                 className="p-2 text-red-600 hover:bg-red-50 rounded-full"
//                               >
//                                 <X size={18} />
//                               </button>
//                             </td>
//                           </>
//                         ) : (
//                           <>
//                             <td className="p-4">
//                               <div className="font-bold text-slate-800">
//                                 {s.name}
//                               </div>
//                               <div className="text-xs text-slate-500">
//                                 {s.mobile_number}
//                               </div>
//                             </td>

//                             <td className="p-4 text-slate-600">
//                               {s.designation}
//                             </td>

//                             <td className="p-4 font-medium text-slate-700">
//                               ₹{s.monthly_salary}
//                             </td>

//                             <td className="p-4 text-right space-x-2">
//                               <button
//                                 onClick={() => {
//                                   setEditingId(s.id);
//                                   setEditStaff(s);
//                                 }}
//                                 className="p-2 text-blue-600 hover:bg-blue-50 rounded-full"
//                               >
//                                 <Edit2 size={18} />
//                               </button>

//                               <button
//                                 onClick={() => deleteStaff(s.id)}
//                                 className="p-2 text-red-600 hover:bg-red-50 rounded-full"
//                               >
//                                 <Trash2 size={18} />
//                               </button>
//                             </td>
//                           </>
//                         )}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ================= ATTENDANCE TAB ================= */}
//         {tab === "attendance" && (
//           <div className="grid lg:grid-cols-12 gap-6">
//             {/* Calendar Sidebar */}
//             <div className="lg:col-span-4 bg-white p-5 rounded-2xl border shadow-sm h-fit">
//               <div className="flex justify-between items-center mb-6">
//                 <button
//                   onClick={() =>
//                     setMonth(
//                       new Date(month.getFullYear(), month.getMonth() - 1),
//                     )
//                   }
//                   className="p-2 hover:bg-slate-100 rounded-full"
//                 >
//                   <ChevronLeft />
//                 </button>
//                 <b className="text-lg">{format(month, "MMMM yyyy")}</b>
//                 <button
//                   onClick={() =>
//                     setMonth(
//                       new Date(month.getFullYear(), month.getMonth() + 1),
//                     )
//                   }
//                   className="p-2 hover:bg-slate-100 rounded-full"
//                 >
//                   <ChevronRight />
//                 </button>
//               </div>
//               <div className="grid grid-cols-7 gap-1 text-center">
//                 {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((d) => (
//                   <div
//                     key={d}
//                     className="text-xs font-bold text-slate-400 py-2"
//                   >
//                     {d}
//                   </div>
//                 ))}
//                 {Array.from({ length: startOfMonth(month).getDay() }).map(
//                   (_, i) => (
//                     <div key={i} />
//                   ),
//                 )}
//                 {eachDayOfInterval({
//                   start: startOfMonth(month),
//                   end: endOfMonth(month),
//                 }).map((d) => (
//                   <button
//                     key={d.toString()}
//                     onClick={() => setSelectedDate(d)}
//                     className={cn(
//                       "h-10 w-10 flex items-center justify-center rounded-xl mx-auto text-sm transition-all",
//                       format(d, "yyyy-MM-dd") ===
//                         format(selectedDate, "yyyy-MM-dd")
//                         ? "bg-indigo-600 text-white shadow-md scale-110"
//                         : "hover:bg-indigo-50 text-slate-600",
//                       isToday(d) && "border-2 border-indigo-200",
//                     )}
//                   >
//                     {format(d, "d")}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* Daily List */}
//             <div className="lg:col-span-8 space-y-4">
//               <div className="flex justify-between items-center mb-2">
//                 <h2 className="text-lg font-bold text-slate-800 italic">
//                   {format(selectedDate, "do MMMM, yyyy")}
//                 </h2>
//                 <span className="text-xs bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full font-bold">
//                   DAILY LOG
//                 </span>
//               </div>
//               {staff.map((s) => {
//                 const rec = attendance.find(
//                   (a) =>
//                     a.staff_id === s.id &&
//                     a.date === format(selectedDate, "yyyy-MM-dd"),
//                 );
//                 const inp = inputs[s.id] || {};

//                 return (
//                   <div
//                     key={s.id}
//                     className="bg-white p-4 rounded-2xl border shadow-sm flex flex-wrap md:flex-nowrap justify-between items-center gap-4"
//                   >
//                     <div className="min-w-[140px]">
//                       <div className="font-bold text-slate-800">{s.name}</div>
//                       <div className="text-xs text-slate-400">
//                         {s.designation}
//                       </div>
//                     </div>

//                     {rec ? (
//                       <div className="flex items-center gap-4 flex-wrap">
//                         <div className="text-right">
//                           <div className="text-xs text-slate-400">
//                             {/* In: {rec.in_time || "--:--"} | Out:{" "}
//                             {rec.out_time || "--:--"} */}
//                             In: {formatIndianTime(rec.in_time)} | Out: {formatIndianTime(rec.out_time)}
//                           </div>
//                           <div className="font-bold text-indigo-600">
//                             Earned: ₹{Math.round(rec.daily_salary || 0)}
//                           </div>
//                         </div>
//                         <StatusBadge status={rec.status} />

//                         {/* Allow updating out-time if not set */}
//                         {!rec.out_time && (
//                           <div className="flex items-center gap-2 bg-amber-50 p-2 rounded-lg border border-amber-200">
//                             <Clock size={14} className="text-amber-600" />
//                             <span className="text-xs text-slate-600">Out:</span>
//                             <input
//                               type="time"
//                               className="text-sm p-1 outline-none border rounded w-24"
//                               value={inp.outTime || ""}
//                               onChange={(e) =>
//                                 setInputs({
//                                   ...inputs,
//                                   [s.id]: { outTime: e.target.value },
//                                 })
//                               }
//                             />
//                             <button
//                               onClick={() => markOutTime(s)}
//                               className="px-3 py-1 bg-blue-600 text-white rounded text-xs font-bold hover:bg-blue-700"
//                             >
//                               OUT
//                             </button>
//                           </div>
//                         )}

//                         {/* Status Update Buttons - Show only if status is pending */}
//                         {rec.status === "pending" && (
//                           <div className="flex gap-1 border-l pl-2">
//                             <button
//                               onClick={() => markAttendance(s, "present")}
//                               className="h-9 w-9 bg-green-600 text-white rounded-lg font-bold text-sm hover:bg-green-700"
//                             >
//                               P
//                             </button>
//                             <button
//                               onClick={() => markAttendance(s, "half-day")}
//                               className="h-9 w-9 bg-blue-600 text-white rounded-lg font-bold text-sm hover:bg-blue-700"
//                             >
//                               H
//                             </button>
//                             <button
//                               onClick={() => markAttendance(s, "absent")}
//                               className="h-9 w-9 bg-red-500 text-white rounded-lg font-bold text-sm hover:bg-red-600"
//                             >
//                               A
//                             </button>
//                           </div>
//                         )}
//                       </div>
//                     ) : (
//                       <div className="flex flex-wrap gap-2 items-center bg-slate-50 p-2 rounded-xl border border-dashed w-full md:w-auto">
//                         {/* In-Time Entry */}
//                         <div className="flex items-center gap-1 bg-white border rounded px-2">
//                           <Clock size={14} className="text-green-500" />
//                           <span className="text-xs text-slate-500">In:</span>
//                           <input
//                             type="time"
//                             className="text-sm p-1 outline-none w-24"
//                             value={inp.inTime || ""}
//                             onChange={(e) =>
//                               setInputs({
//                                 ...inputs,
//                                 [s.id]: { ...inp, inTime: e.target.value },
//                               })
//                             }
//                           />
//                         </div>
//                         <button
//                           onClick={() => markInTime(s)}
//                           className="px-3 py-1.5 bg-green-600 text-white rounded-lg text-xs font-bold hover:bg-green-700"
//                         >
//                           MARK IN
//                         </button>
//                       </div>
//                     )}
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         )}

//         {/* ================= REPORTS TAB ================= */}
//         {tab === "reports" && (
//           <div className="bg-white rounded-2xl border shadow-sm overflow-hidden">
//             <div className="p-6 border-b flex flex-col sm:flex-row justify-between items-center gap-4">
//               <div className="flex items-center gap-2">
//                 <Wallet className="text-indigo-600" />
//                 <h3 className="font-bold text-lg text-slate-800">
//                   Monthly Payroll & Log
//                 </h3>
//               </div>
//               <input
//                 type="month"
//                 value={reportMonth}
//                 onChange={(e) => setReportMonth(e.target.value)}
//                 className="border p-2 rounded-xl focus:ring-2 ring-indigo-100 outline-none font-medium"
//               />
//             </div>

//             <div className="overflow-x-auto">
//               <table className="w-full text-left">
//                 <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
//                   <tr>
//                     <th className="p-4">Staff Member</th>
//                     <th className="p-4 text-center">Present</th>
//                     <th className="p-4 text-center">Half</th>
//                     <th className="p-4 text-center">Absent</th>
//                     <th className="p-4 text-right">Net Salary</th>
//                     <th className="p-4 text-center">Logs</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y">
//                   {staff.map((s) => {
//                     const recs = attendance.filter(
//                       (a) =>
//                         a.staff_id === s.id && a.date.startsWith(reportMonth),
//                     );
//                     const summary = {
//                       p: recs.filter((r) => r.status === "present").length,
//                       h: recs.filter((r) => r.status === "half-day").length,
//                       a: recs.filter((r) => r.status === "absent").length,
//                       total: recs.reduce(
//                         (sum, r) => sum + Number(r.daily_salary || 0),
//                         0,
//                       ),
//                     };


  

//                     return (
//                       <React.Fragment key={s.id}>
//                         <tr className="hover:bg-slate-50">
//                           <td className="p-4 font-bold text-slate-700">
//                             {s.name}
//                           </td>
//                           <td className="p-4 text-center font-semibold text-green-600">
//                             {summary.p}
//                           </td>
//                           <td className="p-4 text-center font-semibold text-yellow-600">
//                             {summary.h}
//                           </td>
//                           <td className="p-4 text-center font-semibold text-red-500">
//                             {summary.a}
//                           </td>
//                           <td className="p-4 text-right font-bold text-slate-900">
//                             ₹{Math.round(summary.total)}
//                           </td>
//                           <td className="p-4 text-center">
//                             <button
//                               onClick={() =>
//                                 setViewDetailId(
//                                   viewDetailId === s.id ? null : s.id,
//                                 )
//                               }
//                               className="p-2 text-indigo-600 hover:bg-indigo-50 rounded-full"
//                             >
//                               <Eye size={18} />
//                             </button>
//                           </td>
//                         </tr>

//                         {/* IN/OUT TIME DETAILS SUB-TABLE */}
//                         {viewDetailId === s.id && (
//                           <tr>
//                             <td colSpan="6" className="bg-slate-50 p-4">
//                               <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-7 gap-2">
//                                 {recs.length > 0 ? (
//                                   recs.map((r) => (
//                                     <div
//                                       key={r.date}
//                                       className="bg-white p-2 rounded-lg border text-[11px] shadow-sm"
//                                     >
//                                       <div className="font-bold border-b mb-1">
//                                         {format(parseISO(r.date), "dd MMM")}
//                                       </div>
//                                       <div className="flex justify-between">
//                                         <span>In:</span>{" "}
                                        
//                                         <span>{formatIndianTime(r.in_time)}</span>

//                                       </div>
//                                       <div className="flex justify-between">
//                                         <span>Out:</span>{" "}
//                                         {/* <span>{r.out_time || "--:--"}</span> */}
//                                         <span>{formatIndianTime(r.out_time)}</span>
//                                       </div>
//                                       <div className="mt-1">
//                                         <StatusBadge status={r.status} />
//                                       </div>
//                                     </div>
//                                   ))
//                                 ) : (
//                                   <div className="col-span-full py-4 text-center text-slate-400">
//                                     No logs found for this month.
//                                   </div>
//                                 )}
//                               </div>
//                             </td>
//                           </tr>
//                         )}
//                       </React.Fragment>
//                     );
//                   })}
//                 </tbody>
//                 <tfoot>
//   <tr className="bg-indigo-50 border-t-2 border-indigo-200">
//     <td className="p-4 font-bold text-indigo-800" colSpan="4">
//       TOTAL PAYROLL AMOUNT
//     </td>
//     <td className="p-4 text-right font-extrabold text-indigo-900 text-lg">
//       ₹{Math.round(grandTotalSalary)}
//     </td>
//     <td />
//   </tr>
// </tfoot>

//               </table>
//             </div>
//           </div>
//         )}
//       </main>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import {
  format,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  isToday,
  parseISO,
} from "date-fns";
import {
  Users,
  Calendar,
  FileText,
  Plus,
  Trash2,
  Edit2,
  Check,
  X,
  ChevronLeft,
  ChevronRight,
  Clock,
  Wallet,
  Eye,
  UserX,
} from "lucide-react";
import { Api } from "../Api/Api";

/* ---------------- HELPERS ---------------- */
const cn = (...c) => c.filter(Boolean).join(" ");
const daysInMonth = (y, m) => new Date(y, m + 1, 0).getDate();
const apiGet = async (url) => (await fetch(Api + url)).json();
const apiPost = async (url, body) =>
  (
    await fetch(Api + url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
  ).json();

export default function AttendanceDashboard() {
  const [tab, setTab] = useState("staff");
  const [staff, setStaff] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [month, setMonth] = useState(startOfMonth(new Date()));
  const [reportMonth, setReportMonth] = useState(format(new Date(), "yyyy-MM"));
  const [viewDetailId, setViewDetailId] = useState(null);

  const [inputs, setInputs] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [newStaff, setNewStaff] = useState({
    name: "",
    mobileNumber: "",
    designation: "",
    monthlySalary: "",
  });
  const [editStaff, setEditStaff] = useState({});

  /* ---------------- LOAD ---------------- */
  const loadStaff = async () => setStaff(await apiGet("staff/list.php"));

  const loadAttendance = async () => {
    if (tab === "reports") {
      setAttendance(await apiGet(`attendance/list.php?month=${reportMonth}`));
    } else {
      setAttendance(
        await apiGet(
          `attendance/list.php?date=${format(selectedDate, "yyyy-MM-dd")}`,
        ),
      );
    }
  };

  useEffect(() => {
    loadStaff();
  }, []);
  useEffect(() => {
    loadAttendance();
  }, [selectedDate, reportMonth, tab]);

  /* ---------------- STAFF ACTIONS ---------------- */
  const addStaff = async () => {
    if (!newStaff.name || !newStaff.monthlySalary)
      return alert("Name & salary required");
    await apiPost("staff/create.php", newStaff);
    setNewStaff({
      name: "",
      mobileNumber: "",
      designation: "",
      monthlySalary: "",
    });
    loadStaff();
  };

  const deleteStaff = async (id) => {
    if (!window.confirm("Delete staff?")) return;
    await apiGet(`staff/delete.php?id=${id}`);
    loadStaff();
  };

  const updateStaff = async () => {
    await apiPost("staff/update.php", editStaff);
    setEditingId(null);
    loadStaff();
  };

  /* ---------------- ATTENDANCE ACTIONS ---------------- */

  const markInTime = async (s) => {
    const date = format(selectedDate, "yyyy-MM-dd");
    const inp = inputs[s.id] || {};
    if (!inp.inTime) return alert("Please select in-time first");

    await apiPost("attendance/mark-time.php", {
      id: `${s.id}-${date}`,
      staffId: s.id,
      date,
      inTime: inp.inTime,
      timeType: "in",
    });
    loadAttendance();
    setInputs({ ...inputs, [s.id]: {} });
  };

  const markAbsentDirectly = async (s) => {
    if (!window.confirm(`Mark ${s.name} as Absent?`)) return;
    const date = format(selectedDate, "yyyy-MM-dd");
    
    await apiPost("attendance/mark-time.php", {
      id: `${s.id}-${date}`,
      staffId: s.id,
      date,
      inTime: null,
      outTime: null,
      status: "absent",
      dailySalary: 0,
      timeType: "absent",
    });
    loadAttendance();
  };

  const markOutTime = async (s) => {
    const date = format(selectedDate, "yyyy-MM-dd");
    const inp = inputs[s.id] || {};
    if (!inp.outTime) return alert("Please select out-time first");

    const rec = attendance.find((a) => a.staff_id === s.id && a.date === date);
    if (!rec) return alert("Please mark in-time first");

    const [y, m] = date.split("-").map(Number);
    const daily = s.monthly_salary / daysInMonth(y, m - 1);
    
    // Default logic if status is still pending/present
    const pay = rec.status === "half-day" ? daily / 2 : rec.status === "absent" ? 0 : daily;

    await apiPost("attendance/mark-time.php", {
      id: `${s.id}-${date}`,
      staffId: s.id,
      date,
      outTime: inp.outTime,
      timeType: "out",
      dailySalary: pay,
    });
    loadAttendance();
    setInputs({ ...inputs, [s.id]: {} });
  };

  const markAttendance = async (s, status) => {
    const date = format(selectedDate, "yyyy-MM-dd");
    const [y, m] = date.split("-").map(Number);
    const daily = s.monthly_salary / daysInMonth(y, m - 1);
    const pay = status === "present" ? daily : status === "half-day" ? daily / 2 : 0;

    await apiPost("attendance/update-status.php", {
      id: `${s.id}-${date}`,
      status,
      dailySalary: pay,
    });
    loadAttendance();
  };

  /* ---------------- UI COMPONENTS ---------------- */
  const StatusBadge = ({ status }) => {
    const colors = {
      present: "bg-green-100 text-green-700",
      "half-day": "bg-yellow-100 text-yellow-700",
      absent: "bg-red-100 text-red-700",
      pending: "bg-gray-100 text-gray-600",
    };
    return (
      <span className={cn("px-2 py-1 rounded-md text-[10px] font-bold uppercase", colors[status])}>
        {status}
      </span>
    );
  };

  const formatIndianTime = (time) => {
    if (!time || time === "00:00:00") return "--:--";
    const [h, m] = time.split(":");
    const date = new Date();
    date.setHours(h, m);
    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const grandTotalSalary = staff.reduce((sum, s) => {
    const recs = attendance.filter((a) => a.staff_id === s.id && a.date.startsWith(reportMonth));
    return sum + recs.reduce((t, r) => t + Number(r.daily_salary || 0), 0);
  }, 0);

  return (
    <div className="min-h-screen bg-slate-50 pb-20">
      <div className="sticky top-0 z-10 bg-white border-b px-4 py-3 mb-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <h1 className="text-xl font-bold text-slate-800">Staff ERP</h1>
          <div className="flex bg-slate-100 p-1 rounded-xl w-full md:w-auto overflow-x-auto no-scrollbar">
            {[
              { id: "staff", label: "Staff", icon: Users },
              { id: "attendance", label: "Attendance", icon: Calendar },
              { id: "reports", label: "Payroll", icon: FileText },
            ].map((t) => (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                className={cn(
                  "flex-1 md:flex-none px-2 md:px-4 py-2 flex items-center justify-center gap-2 rounded-lg transition-all whitespace-nowrap",
                  tab === t.id ? "bg-white shadow-sm text-indigo-600" : "text-slate-500 hover:text-slate-700"
                )}
              >
                <t.icon size={18} className="shrink-0" />
                <span className="hidden sm:inline text-sm font-medium">{t.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4">
        {/* ================= STAFF TAB ================= */}
        {tab === "staff" && (
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-2xl border shadow-sm">
              <h3 className="font-bold mb-4 flex items-center gap-2 text-slate-700">
                <Plus size={20} /> Add New Staff
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                <input
                  placeholder="Full Name"
                  className="border p-2.5 rounded-lg focus:ring-2 ring-indigo-100 outline-none"
                  value={newStaff.name}
                  onChange={(e) => setNewStaff({ ...newStaff, name: e.target.value })}
                />
                <input
                  placeholder="Designation"
                  className="border p-2.5 rounded-lg focus:ring-2 ring-indigo-100 outline-none"
                  value={newStaff.designation}
                  onChange={(e) => setNewStaff({ ...newStaff, designation: e.target.value })}
                />
                <input
                  placeholder="Mobile Number"
                  className="border p-2.5 rounded-lg focus:ring-2 ring-indigo-100 outline-none"
                  value={newStaff.mobileNumber}
                  onChange={(e) => setNewStaff({ ...newStaff, mobileNumber: e.target.value })}
                />
                <input
                  placeholder="Monthly Salary"
                  type="number"
                  className="border p-2.5 rounded-lg focus:ring-2 ring-indigo-100 outline-none"
                  value={newStaff.monthlySalary}
                  onChange={(e) => setNewStaff({ ...newStaff, monthlySalary: e.target.value })}
                />
                <button
                  onClick={addStaff}
                  className="md:col-span-4 bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 rounded-lg transition-colors"
                >
                  SAVE STAFF MEMBER
                </button>
              </div>
            </div>

            <div className="bg-white rounded-2xl border shadow-sm overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="bg-slate-50 text-slate-500 text-sm uppercase">
                      <th className="p-4 font-semibold w-12">#</th>
                      <th className="p-4 font-semibold">Staff Details</th>
                      <th className="p-4 font-semibold">Designation</th>
                      <th className="p-4 font-semibold">Salary</th>
                      <th className="p-4 font-semibold text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {staff.map((s, index) => (
                      <tr key={s.id} className="hover:bg-slate-50 transition-colors">
                        <td className="p-4 font-bold text-slate-600">{index + 1}</td>
                        {editingId === s.id ? (
                          <>
                            <td className="p-4">
                              <input className="border p-2 rounded w-full" value={editStaff.name} onChange={(e) => setEditStaff({ ...editStaff, name: e.target.value })} />
                              <input className="border p-2 rounded w-full mt-1" value={editStaff.mobile_number} onChange={(e) => setEditStaff({ ...editStaff, mobile_number: e.target.value })} />
                            </td>
                            <td className="p-4">
                              <input className="border p-2 rounded w-full" value={editStaff.designation} onChange={(e) => setEditStaff({ ...editStaff, designation: e.target.value })} />
                            </td>
                            <td className="p-4">
                              <input type="number" className="border p-2 rounded w-full" value={editStaff.monthly_salary} onChange={(e) => setEditStaff({ ...editStaff, monthly_salary: e.target.value })} />
                            </td>
                            <td className="p-4 text-right space-x-2">
                              <button onClick={updateStaff} className="p-2 text-green-600 hover:bg-green-50 rounded-full"><Check size={18} /></button>
                              <button onClick={() => setEditingId(null)} className="p-2 text-red-600 hover:bg-red-50 rounded-full"><X size={18} /></button>
                            </td>
                          </>
                        ) : (
                          <>
                            <td className="p-4">
                              <div className="font-bold text-slate-800">{s.name}</div>
                              <div className="text-xs text-slate-500">{s.mobile_number}</div>
                            </td>
                            <td className="p-4 text-slate-600">{s.designation}</td>
                            <td className="p-4 font-medium text-slate-700">₹{s.monthly_salary}</td>
                            <td className="p-4 text-right space-x-2">
                              <button onClick={() => { setEditingId(s.id); setEditStaff(s); }} className="p-2 text-blue-600 hover:bg-blue-50 rounded-full"><Edit2 size={18} /></button>
                              <button onClick={() => deleteStaff(s.id)} className="p-2 text-red-600 hover:bg-red-50 rounded-full"><Trash2 size={18} /></button>
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* ================= ATTENDANCE TAB ================= */}
        {tab === "attendance" && (
          <div className="grid lg:grid-cols-12 gap-6">
            <div className="lg:col-span-4 bg-white p-5 rounded-2xl border shadow-sm h-fit">
              <div className="flex justify-between items-center mb-6">
                <button onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() - 1))} className="p-2 hover:bg-slate-100 rounded-full"><ChevronLeft /></button>
                <b className="text-lg">{format(month, "MMMM yyyy")}</b>
                <button onClick={() => setMonth(new Date(month.getFullYear(), month.getMonth() + 1))} className="p-2 hover:bg-slate-100 rounded-full"><ChevronRight /></button>
              </div>
              <div className="grid grid-cols-7 gap-1 text-center">
                {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((d) => (
                  <div key={d} className="text-xs font-bold text-slate-400 py-2">{d}</div>
                ))}
                {Array.from({ length: startOfMonth(month).getDay() }).map((_, i) => <div key={i} />)}
                {eachDayOfInterval({ start: startOfMonth(month), end: endOfMonth(month) }).map((d) => (
                  <button
                    key={d.toString()}
                    onClick={() => setSelectedDate(d)}
                    className={cn(
                      "h-10 w-10 flex items-center justify-center rounded-xl mx-auto text-sm transition-all",
                      format(d, "yyyy-MM-dd") === format(selectedDate, "yyyy-MM-dd") ? "bg-indigo-600 text-white shadow-md scale-110" : "hover:bg-indigo-50 text-slate-600",
                      isToday(d) && "border-2 border-indigo-200"
                    )}
                  >
                    {format(d, "d")}
                  </button>
                ))}
              </div>
            </div>

            <div className="lg:col-span-8 space-y-4">
              <div className="flex justify-between items-center mb-2">
                <h2 className="text-lg font-bold text-slate-800 italic">{format(selectedDate, "do MMMM, yyyy")}</h2>
                <span className="text-xs bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full font-bold">DAILY LOG</span>
              </div>
              {staff.map((s) => {
                const rec = attendance.find((a) => a.staff_id === s.id && a.date === format(selectedDate, "yyyy-MM-dd"));
                const inp = inputs[s.id] || {};

                return (
                  <div key={s.id} className="bg-white p-4 rounded-2xl border shadow-sm flex flex-wrap md:flex-nowrap justify-between items-center gap-4">
                    <div className="min-w-[140px]">
                      <div className="font-bold text-slate-800">{s.name}</div>
                      <div className="text-xs text-slate-400">{s.designation}</div>
                    </div>

                    {rec ? (
                      <div className="flex items-center gap-4 flex-wrap">
                        <div className="text-right">
                          {rec.status !== "absent" && (
                            <div className="text-xs text-slate-400">
                              In: {formatIndianTime(rec.in_time)} | Out: {formatIndianTime(rec.out_time)}
                            </div>
                          )}
                          <div className="font-bold text-indigo-600">Earned: ₹{Math.round(rec.daily_salary || 0)}</div>
                        </div>
                        <StatusBadge status={rec.status} />
                        {rec.status !== "absent" && !rec.out_time && (
                          <div className="flex items-center gap-2 bg-amber-50 p-2 rounded-lg border border-amber-200">
                            <Clock size={14} className="text-amber-600" />
                            <input type="time" className="text-sm p-1 outline-none border rounded w-24" value={inp.outTime || ""} onChange={(e) => setInputs({ ...inputs, [s.id]: { outTime: e.target.value } })} />
                            <button onClick={() => markOutTime(s)} className="px-3 py-1 bg-blue-600 text-white rounded text-xs font-bold">OUT</button>
                          </div>
                        )}
                        {rec.status === "pending" && (
                          <div className="flex gap-1 border-l pl-2">
                            <button onClick={() => markAttendance(s, "present")} className="h-9 w-9 bg-green-600 text-white rounded-lg font-bold text-sm">P</button>
                            <button onClick={() => markAttendance(s, "half-day")} className="h-9 w-9 bg-blue-600 text-white rounded-lg font-bold text-sm">H</button>
                            {/* <button onClick={() => markAttendance(s, "absent")} className="h-9 w-9 bg-red-500 text-white rounded-lg font-bold text-sm">A</button> */}
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="flex flex-wrap gap-2 items-center">
                        <div className="flex items-center gap-2 bg-slate-50 p-2 rounded-xl border border-dashed">
                          <div className="flex items-center gap-1 bg-white border rounded px-2">
                            <Clock size={14} className="text-green-500" />
                            <input type="time" className="text-sm p-1 outline-none w-24" value={inp.inTime || ""} onChange={(e) => setInputs({ ...inputs, [s.id]: { ...inp, inTime: e.target.value } })} />
                          </div>
                          <button onClick={() => markInTime(s)} className="px-3 py-1.5 bg-green-600 text-white rounded-lg text-xs font-bold">MARK IN</button>
                        </div>
                        <div className="text-slate-300">OR</div>
                        <button onClick={() => markAbsentDirectly(s)} className="flex items-center gap-1 px-3 py-2 bg-red-50 text-red-600 border border-red-100 rounded-lg text-xs font-bold hover:bg-red-100">
                          <UserX size={14} /> ABSENT
                        </button>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* ================= REPORTS TAB ================= */}
        {tab === "reports" && (
          <div className="bg-white rounded-2xl border shadow-sm overflow-hidden">
            <div className="p-6 border-b flex flex-col sm:flex-row justify-between items-center gap-4">
              <div className="flex items-center gap-2">
                <Wallet className="text-indigo-600" />
                <h3 className="font-bold text-lg text-slate-800">Monthly Payroll & Log</h3>
              </div>
              <input type="month" value={reportMonth} onChange={(e) => setReportMonth(e.target.value)} className="border p-2 rounded-xl outline-none font-medium" />
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
                  <tr>
                    <th className="p-4">Staff Member</th>
                    <th className="p-4 text-center">Present</th>
                    <th className="p-4 text-center">Half</th>
                    <th className="p-4 text-center">Absent</th>
                    <th className="p-4 text-right">Net Salary</th>
                    <th className="p-4 text-center">Logs</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {staff.map((s) => {
                    const recs = attendance.filter((a) => a.staff_id === s.id && a.date.startsWith(reportMonth));
                    const summary = {
                      p: recs.filter((r) => r.status === "present").length,
                      h: recs.filter((r) => r.status === "half-day").length,
                      a: recs.filter((r) => r.status === "absent").length,
                      total: recs.reduce((sum, r) => sum + Number(r.daily_salary || 0), 0),
                    };
                    return (
                      <React.Fragment key={s.id}>
                        <tr className="hover:bg-slate-50">
                          <td className="p-4 font-bold text-slate-700">{s.name}</td>
                          <td className="p-4 text-center font-semibold text-green-600">{summary.p}</td>
                          <td className="p-4 text-center font-semibold text-yellow-600">{summary.h}</td>
                          <td className="p-4 text-center font-semibold text-red-500">{summary.a}</td>
                          <td className="p-4 text-right font-bold text-slate-900">₹{Math.round(summary.total)}</td>
                          <td className="p-4 text-center">
                            <button onClick={() => setViewDetailId(viewDetailId === s.id ? null : s.id)} className="p-2 text-indigo-600 hover:bg-indigo-50 rounded-full"><Eye size={18} /></button>
                          </td>
                        </tr>
                        {viewDetailId === s.id && (
                          <tr>
                            <td colSpan="6" className="bg-slate-50 p-4">
                              <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-7 gap-2">
                                {recs.length > 0 ? recs.map((r) => (
                                  <div key={r.date} className="bg-white p-2 rounded-lg border text-[11px] shadow-sm">
                                    <div className="font-bold border-b mb-1">{format(parseISO(r.date), "dd MMM")}</div>
                                    <div className="flex justify-between"><span>In:</span> <span>{formatIndianTime(r.in_time)}</span></div>
                                    <div className="flex justify-between"><span>Out:</span> <span>{formatIndianTime(r.out_time)}</span></div>
                                    <div className="mt-1"><StatusBadge status={r.status} /></div>
                                  </div>
                                )) : <div className="col-span-full py-4 text-center text-slate-400">No logs found for this month.</div>}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr className="bg-indigo-50 border-t-2 border-indigo-200">
                    <td className="p-4 font-bold text-indigo-800" colSpan="4">TOTAL PAYROLL AMOUNT</td>
                    <td className="p-4 text-right font-extrabold text-indigo-900 text-lg">₹{Math.round(grandTotalSalary)}</td>
                    <td />
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}